<template>
  <v-card outlined class="ma-2" elevation="2">
    <v-card-title class="text-h5 title-header"
      >{{ $t("llm_config.language_agent.title") }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t("llm_config.language_agent.description") }}
    </v-card-subtitle>
    <v-card-text>
      <v-textarea
        v-model="custom_instructions"
        :label="$t('llm_config.language_agent.custom_instructions_label')"
        :rules="form_roles.optionalField"
        rows="4"
        :placeholder="
          $t('llm_config.language_agent.custom_instructions_placeholder')
        "
        variant="filled"
        outlined
        required
        clearable
        @click:clear="custom_instructions = null"
      >
      </v-textarea>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LangageAgentConfig",
  data() {
    return {};
  },
  props: {
    openaiConfig: {
      type: Object,
      required: true,
    },
    form_roles: {
      type: Object,
      default: () => ({
        text: [],
      }),
      required: true,
    },
  },
  created() {
    if (!this.openaiConfig?.langchain_settings?.langage_agent) {
      this.$set(this.openaiConfig.langchain_settings, "langage_agent", {
        custom_instructions: "",
      });
    }
  },
  computed: {
    custom_instructions: {
      get() {
        return (
          this.openaiConfig?.langchain_settings?.langage_agent
            ?.custom_instructions || ""
        );
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings.langage_agent,
          "custom_instructions",
          value
        );
      },
    },
  },
  watch: {
    custom_instructions(newVal) {
      if (newVal === "") {
        this.$set(
          this.openaiConfig.langchain_settings.langage_agent,
          "custom_instructions",
          null
        );
      }
    },
  },
};
</script>

<style scoped>
.title-header {
  font-weight: bold;
  color: #1141ce !important;
}
.v-chip {
  height: auto !important;
}

.v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>
